// export const base_url = "https://xenonify-bookdemo-backend.lab.neuralcompany.team/";
export const base_url="https://app.akira.ai/api/auth"
